import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-secure-access',
  templateUrl: './secure-access.component.html',
  styleUrls: ['./secure-access.component.scss']
})
export class SecureAccessComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit(): void {
    const otp = this.route.snapshot.queryParamMap.get('otp');
    const cho = this.route.snapshot.queryParamMap.get('cho');
    if (otp) {
      this.http.get<{ token: string }>(`/api/public/secure-access?otp=${otp}`)
        .subscribe({
          next: res => {
            sessionStorage.setItem('jwt', res.token);
            sessionStorage.setItem('cho', cho);
            this.router.navigate(['/home']);
          },
          error: () => {
            alert('OTP non valido o scaduto');
            this.router.navigate(['/']);
          }
        });
    } else {
      this.router.navigate(['/']);
    }
  }
}
